import React, { useState, useEffect } from "react";
import { Button, Space, message } from "antd";
import TableContainer from "../../components/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getHubReconciliationList, startHubReconciliation, clearStartHubReconciliation } from "../../actionsMethods/hubReconciliationMethods";
import { getToken, getPremiseId } from "../../utils/worker";
import Smcs_Loader from "../../assests/images/loader-new.gif";

const HubReconciliation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const {
    fetching: isFetching,
    result: listData,
  } = useSelector((state) => state.hubReconciliationReducer.getHubReconciliationList);

  const {
    result: startData,
    error: startError,
  } = useSelector((state) => state.hubReconciliationReducer.startHubReconciliation);

  const fetchReconciliationData = (page = 1, pageSize = 10) => {
    const tokenStr = getToken();
    const token = tokenStr?.startsWith("Bearer ") ? tokenStr.split("Bearer ")[1] : tokenStr;

    const premiseIdStr = getPremiseId();
    const premiseId = premiseIdStr?.startsWith("Bearer ") ? premiseIdStr.split("Bearer ")[1] : premiseIdStr;

    dispatch(getHubReconciliationList({ page, pageSize, token, premiseId }));
  };

  useEffect(() => {
    if (listData) {
      const responseData = listData.data || listData || {};
      let extractedData = [];
      if (Array.isArray(responseData.data)) {
        extractedData = responseData.data;
      } else if (Array.isArray(responseData)) {
        extractedData = responseData;
      } else if (Array.isArray(listData)) {
        extractedData = listData;
      }

      setData(extractedData);
      setPagination({
        current: (responseData.pageNum || 0) + 1,
        pageSize: responseData.pageSize || 10,
        total: responseData.totalCount || 0,
      });
    }
  }, [listData]);

  const handleStartReconciliation = () => {
    const tokenStr = getToken();
    const token = tokenStr?.startsWith("Bearer ") ? tokenStr.split("Bearer ")[1] : tokenStr;

    const premiseIdStr = getPremiseId();
    const premiseId = premiseIdStr?.startsWith("Bearer ") ? premiseIdStr.split("Bearer ")[1] : premiseIdStr;

    const userInfoData = JSON.parse(localStorage.getItem("userId") || "{}");
    const userId = userInfoData?.userInfo?.userId ? userInfoData.userInfo.userId.toString() : "";
    const premiseName = userInfoData?.premises?.premiseName || userInfoData?.userInfo?.premiseName || "Hub";

    dispatch(startHubReconciliation({ token, premiseId, userId, premiseName }));
  };

  useEffect(() => {
    if (startData) {
      const reconcileId = startData?.data?.reconcileId || startData?.reconcileId;
      if (reconcileId) {
        window.open(`/start-reconciliation?reconcileId=${reconcileId}`, "_blank");
        dispatch(clearStartHubReconciliation());
      }
    } else if (startError) {
      const errorMsg = startError?.data?.message || startError?.message || "Failed to start reconciliation";
      message.error(errorMsg, 1);
      dispatch(clearStartHubReconciliation());
    }
  }, [startData, startError, dispatch]);

  useEffect(() => {
    dispatch(clearStartHubReconciliation());
    fetchReconciliationData();
  }, [dispatch]);

  const handleTableChange = (newPagination) => {
    fetchReconciliationData(newPagination.current, newPagination.pageSize);
  };

  const columns = [
    {
      title: "Reconcile ID",
      dataIndex: "reconcileId",
      key: "reconcileId",
      align: "center",
      width: 120,
      render: (text, record) => {
        if (record.status === "IN_PROGRESS") {
          return (
            <span
              style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
              onClick={() => window.open(`/start-reconciliation?reconcileId=${record.reconcileId}`, "_blank")}
            >
              {text}
            </span>
          );
        }
        return text;
      }
    },
    { title: "Started At", dataIndex: "startedAt", key: "startedAt", align: "center" },
    {
      title: "Closed At",
      dataIndex: "closedAt",
      key: "closedAt",
      align: "center",
      render: (text) => text || "---"
    },
    { title: "Started By", dataIndex: "startedBy", key: "startedBy", align: "center" },
    { title: "Premise Name", dataIndex: "premiseName", key: "premiseName", align: "center" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => {
        let color = "inherit";
        if (status === "CLOSED") {
          color = "red";
        } else if (status === "IN_PROGRESS") {
          color = "#faad14"; // Ant Design standard yellow/gold
        }
        return <span style={{ color, fontWeight: 500 }}>{status}</span>;
      }
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="primary"
            className="save-btn"
            disabled={record.status === "IN_PROGRESS"}
            onClick={() => navigate(`/hub-reconciliation-report?reconcileId=${record.reconcileId}`)}
          >
            Report
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="dashboard-container" style={{ padding: "20px" }}>
      <div className="align-center space-between" style={{ marginBottom: 16 }}>
        <div className="pl-1-5 fw-600" style={{ fontSize: 20 }}>
          Hub Reconciliation
        </div>
      </div>
      <div className="master-main-container view-all-staff">
        <div className="text-right p-1" style={{ marginBottom: 16 }}>
          <Space>
            <Button
              type="primary"
              className="save-btn"
              onClick={handleStartReconciliation}
            >
              Start Reconciliation
            </Button>
          </Space>
        </div>
        <TableContainer
          className="table-head-sticky"
          dataSource={data}
          columns={columns}
          rowKey="reconcileId"
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: isFetching,
          }}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default HubReconciliation;
